// Loads the jsPDF-backed certificate renderer only when a certificate is actually downloaded.
export async function downloadCertificate(opts) {
  const { downloadCertificate: run } = await import("@/lib/certificate");
  return run(opts);
}

export async function certificateFile(opts) {
  const { certificateFile: run } = await import("@/lib/certificate");
  return run(opts);
}
